import { useRequestGetEmployees } from '@/hooks/httpRequest';
import { DataTablePageSizeEnum } from '@/enums';
import { useQueryParams } from '@/hooks';

const useEmployees = () => {

  const { values: [limit, page] } = useQueryParams(
    ['limit', 'page'],
    { limit: DataTablePageSizeEnum._50, page: 1 }
  );
  const result = useRequestGetEmployees({ limit, page });

  return result;
}

export default useEmployees;
